require('./bootstrap');
// require('./../../node_modules/jquery-ui/dist/jquery-ui.min');
require('./quiz');
